const ASSIGNMENT_MODAL_OPEN = 'ASSIGNMENT_MODAL_OPEN';
const ASSIGNMENT_MODAL_CLOSE = 'ASSIGNMENT_MODAL_CLOSE';
const ASSIGNMENT_MODAL_BUTTON_DISABLE = 'ASSIGNMENT_MODAL_BUTTON_DISABLE';
const ASSIGNMENT_MODAL_BUTTON_ABLE = 'ASSIGNMENT_MODAL_BUTTON_ABLE';
const ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_OPEN =
  'ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_OPEN';
const ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_CLOSE =
  'ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_CLOSE';
export {
  ASSIGNMENT_MODAL_BUTTON_ABLE,
  ASSIGNMENT_MODAL_BUTTON_DISABLE,
  ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_CLOSE,
  ASSIGNMENT_MODAL_CLOSE,
  ASSIGNMENT_MODAL_OPEN,
  ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_OPEN,
};
